import { useTranslation } from "react-i18next";

export default function LaunchpadFooter() {
  const { t } = useTranslation("launchpad");

  return <p className="px-4 pt-4 flex align-middle font-medium text-xs">
    <span>
      {t("footer-powered-by")}<a className="text-accent" href="https://saltplatform.com" target="_blank" rel="noopener noreferrer">Salt</a>{t("footer-extra")}. {t("copyright", { year: new Date().getFullYear() })}
    </span>
  </p>
}